import { Button as NaskaButton } from '@nazka/nazka.mapframe.components';

import './button.css';

function Button(props) {
  return (
    <NaskaButton 
      className="button"
      {...props}
    />
  )
}

export default Button;